import React from 'react';

const MyBlogs = () => {
    return (
        <div className='text-center text-6xl my-56'>
            <h1>My Blogs are coming soon</h1>
        </div>
    );
};

export default MyBlogs;